
import jsonExport from 'jsonexport/dist';
import moment from "moment";
import { useContext } from "react";
import { AutocompleteInput, BooleanField, BooleanInput, CreateButton, Datagrid, downloadCSV, ExportButton, FilterButton, List, ReferenceInput, sanitizeListRestProps, SelectInput, TextField, TextInput, TopToolbar, useListContext } from "react-admin";
import UserImportButton from '../../components/user-import-button/user-import-button';
import { AppContext } from '../../providers/app-context-provider/app.context';
import { ProfileEnum } from '../../utils/general-profile.enum';


const userFilters = [
    <TextInput label='Nome' source='name' alwaysOn />,
    <TextInput label='Email' source='email' />,
    <BooleanInput label='Ativo' source='active' />,
    <SelectInput label='Perfil' source='profile' optionText={"id"} choices={[{ id: "Aluno" }, { id: "Administrador" }, { id: "Advogado" }, { id: "Coordenador" }, { id: "Professor" }, { id: "Secretaria" }]} />,

]

const coordFilters = [
    <ReferenceInput label="Unidade" source="institution_branch" reference="institution-branches" filterToQuery={(text) => ({ "institution_branch.name": text })} sort={{ field: "name", order: "ASC" }} >
        <AutocompleteInput
            optionText="name"
            optionValue="id"
            source="name"
            emptyText="Todos"
            fullWidth
        />
    </ReferenceInput>
]

const exporter = data => {
    const toExport = data.map(item => {
        return {
            name: item.user.name,
            email: item.user.email,
            active: item.user.active ? "Ativo" : "Inativo",
            profile: item.profile.name,
            created_at: moment(item.created_at).format('DD/MM/YYYY')
        }
    })
    jsonExport(toExport, {
        headers: ['name', 'email', 'active', 'profile', 'created_at'],
        rename: ['Nome', 'Email', 'Ativo', 'Perfil', 'Criado em'],
    },
        (err, csv) => {
            downloadCSV(csv, `Exportar_Alunos_${moment().format('YYYY_MM_DD_HH_mm')}`)
        })
}

const UserListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        basePath,
    } = useListContext();
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            <FilterButton />
            <CreateButton basePath={basePath} />
            <ExportButton />
            <UserImportButton label={'Importar usuários'} />
        </TopToolbar>
    );
}
const UserContextList = (props) => {

    const context = useContext(AppContext)
    const superAdmin = context.profile.name === ProfileEnum.SUPERADMIN;

    return (
        <List
            exporter={exporter}
            bulkActionButtons={false}
            title={'Usuários'}
            sort={{ field: 'user.name', order: 'ASC' }}
            filters={context.profile.name === ProfileEnum.GENERAL_PRINCIPAL ? [...userFilters, ...coordFilters] : userFilters}
            actions={<UserListActions />}
            {...props}
        >
            <Datagrid rowClick={'edit'}>
                <TextField source="user.name" label={'Nome'} />
                <TextField source="user.email" label={'Email'} />
                <TextField source="user.phone" label={'Telefone'} />
                <BooleanField source="active" label={'Ativo'} />
                <TextField source='profile.name' label={'Perfil'} />
                {superAdmin && <TextField source='institution_branch.institution.name' label={'Instituição'} />}
                {(superAdmin || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && <TextField source='institution_branch.name' label={'Unidade'} />}
            </Datagrid>
        </List>
    )
}

export default UserContextList;